import { branch, renderNothing } from 'recompose'

import { withRouter } from 'i18n/utils'
import { getNews } from 'news/actions'

import { categorySelector } from '../selectors'
import NewsList from './NewsList'

class Archive extends Component {
    componentDidMount() {
        const { category, location, getNews } = this.props
        const { search = '', page = 1 } = location.query

        getNews(category, search, page)
    }

    render() {
        return (
            <div className="row archive m-0">
                <NewsList category={this.props.category} />
            </div>
        )
    }
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            category: categorySelector,
        }),
        { getNews }
    ),
    branch(props => !props.category && !props.uncategorized, renderNothing)
)(Archive)
